module.exports = __webpack_public_path__ + "static/media/hiace.6559f7df.jpeg";